import React from "react";
import Line from "./line.js";
const Node = ({ label, x, y, type, themeMode, header, id ,solutionHeight}) => {
  let solutioncheck = (type === "solution" || id === "solution-header");
  return (
    <div
      className={`absolute shadow-md rounded-lg p-4 border  border-2
        ${
          header
            ? "text-white bg-[#44a5e4] p-2 inline-block text-center rounded-md  min-h-[30px]"
            : themeMode === "dark"
            ? `bg-[#000000] hover:bg-[#100c1a] text-white cursor-pointer border-gray-600 ${solutionHeight !== undefined ? "text-center flex items-center justify-center " : ""}`
            : `bg-white text-gray-800 cursor-pointer border-gray-300 ${solutionHeight !== undefined ? "text-center flex items-center justify-center " : ""}`
        }`}
      style={{
        left: `${x}px`,
        top: `${y}px`,
        width:
          solutioncheck===false? "400px" : "300px",
        height: solutionHeight!==undefined?solutionHeight:"60px",
        overflow: "hidden",
      }}
    >
      <h3 className={`${header?"text-lg font-bold":"text-sm font-semibold"} `}>{label}</h3>
    </div>
  );
};

const Edge = ({ sourceX, sourceY, targetX, targetY, themeMode }) => {
  const width = targetX - sourceX;
  const height = targetY - sourceY;
  const angle = Math.atan2(height, width); // Çizginin açısını hesapla
  const lineLength = Math.sqrt(width ** 2 + height ** 2); // Çizgi uzunluğu

  return (
    <>
      {/* Ana Çizgi */}
      <div
        className="absolute"
        style={{
          left: `${sourceX}px`,
          top: `${sourceY}px`,
          width: `${lineLength}px`,
          borderTop:
            themeMode === "dark" ? "1px dashed white" : "1px dashed black",
          transform: `rotate(${angle}rad)`,
          transformOrigin: "0 0",
        }}
      />

      {/* Ok İşareti */}
      <div
        style={{
          position: "absolute",
          left: `${targetX}px`,
          top: `${targetY}px`,
          transform: `translate(-50%, -50%) rotate(${angle + Math.PI / 2}rad)`,
        }}
      >
        <div
          style={{
            width: "0",
            height: "0",
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderBottom:
              themeMode === "dark"
                ? "10px solid white"
                : "10px solid black", // Ok rengi
          }}
        />
      </div>
    </>
  );
};



const MAX_PAGE_HEIGHT = 750;

const Graph = ({ themeMode, data }) => {
  const findingsMap = new Map();

  data?.findings.forEach((finding) => {
    const sectionName = finding.section_name;
  
    // Eğer section daha önce eklenmediyse, boş bir obje oluştur
    if (!findingsMap.has(sectionName)) {
      findingsMap.set(sectionName, { findings: [], recommendations: [] });
    }
  
    // Mevcut section'ı al ve yeni verileri ekle
    const sectionData = findingsMap.get(sectionName);
    sectionData.findings.push(finding.finding);
  
    // İlgili recommendation'ları bul ve ekle
    const relatedRecommendations = data?.recommendations
    .filter((rec) => rec.finding_id === finding.finding_id)
    .map((rec) => rec.recommendation); // Sadece recommendation değerlerini al
  
  // Eğer boş değilse ekle

  
    sectionData.recommendations.push(...relatedRecommendations);
  });
  
  // Sonucu bir array formatına çevir
  const mappedData = Array.from(findingsMap, ([section_name, data]) => ({
    section_name,
    ...data,
  }));
  
  const groupedFindings = Object.fromEntries(findingsMap);
  const nodes = [];
  const edges = [];
  let challengeY = 65;
  let solutionY=65
let   recommendationY=65;
  nodes.push(
    {
      id: "challenge-header",
      type: "challenge-header",
      label: "FINDINGS",
      style: { x: 50, y: 0 },
      header: true,
    },
    {
      id: "solution-header",
      type: "solution-header",
      label: "SOLUTION THEMES",
      style: { x: 650, y: 0 },
      header: true,
    },
    {
      id: "description-header",
      type: "description-header",
      label: "DESCRIPTION",
      style: { x: 1000, y: 0 },
      header: true,
    }
  );

  const solutionGroups = [];

  Object.entries(groupedFindings).forEach(([section, findings], index) => {
    let currentChallenges = [];
    let currentRecommendations= [];
    let totalChallengesHeight = 0;
    findings.findings.forEach((finding, findinIndex) => {
      const challengeId = `challenge-${section}-${findinIndex}`;
      nodes.push({
        id: challengeId,
        data: { type: "challenge", taskDescription: finding },
        header: false,
        style: { x: 50, y: challengeY },
      });
      currentChallenges.push(challengeId);
      totalChallengesHeight += 60;
      challengeY += 65;
    });
    findings.recommendations.forEach((recommendation, recommendationIndex) => {
      const challengeId = `recommendation-${section}-${recommendationIndex}`;
      nodes.push({
        id: challengeId,
        data: { type: "recommendation", taskDescription: recommendation },
        header: false,
        style: { x: 1000, y: recommendationY },
      });
      currentRecommendations.push(challengeId);
      recommendationY += 65;
    });
    // const solutionY = challengeY - totalChallengesHeight / 2;
    nodes.push({
      id: section,
      data: { type: "solution", taskDescription: section },
      header: false,
      solutionHeight:(currentChallenges.length-1)*5+totalChallengesHeight,
      style: { x: 650, y: solutionY },
    });
    solutionY +=(currentChallenges.length-1)*5+totalChallengesHeight+5;
    solutionGroups.push({ section, challenges: currentChallenges,recommendations:currentRecommendations });
  })
  const pages = [];
  let currentPageStartIndex = 0;

  while (currentPageStartIndex < solutionGroups.length) {
    let pageHeight = 0;
    let nextPageEndIndex = currentPageStartIndex;
    const nodesOnPage = [];
    const edgesOnPage = [];

    let minY = Infinity;

    // Her sayfa için header ekleyelim
    const headers = [
      { id: "challenge-header", label: "FINDINGS", x: 50, y: 0 },
      { id: "solution-header", label: "SOLUTION THEMES", x: 650, y: 0 },
      { id: "description-header", label: "DESCRIPTION", x: 1000, y: 0 },
    ];

    while (nextPageEndIndex < solutionGroups.length) {
      const { section, challenges,recommendations } = solutionGroups[nextPageEndIndex];
      const solutionNode = nodes.find((n) => n.id === section);
      const challengeNodes = challenges.map((id) =>
        nodes.find((n) => n.id === id)
      );
      const recommendationNodes = recommendations.map((id) =>
        nodes.find((n) => n.id === id)
      );
      const groupHeight = challengeNodes.length * 60;
      if (pageHeight + groupHeight > MAX_PAGE_HEIGHT && pageHeight > 0) break;

      nodesOnPage.push(solutionNode, ...challengeNodes,...recommendationNodes);
      challengeNodes.forEach((challengeNode) => {
        minY = Math.min(minY, challengeNode.style.y);
        edgesOnPage.push({
          source: challengeNode.id,
          target: solutionNode.id,
          sourceX: challengeNode.style.x + 400,
          sourceY: challengeNode.style.y + 30,
          targetX: solutionNode.style.x,
          targetY: solutionNode.style.y + solutionNode.solutionHeight/2,
        });
      });
      
      recommendationNodes.forEach((recommendationNode) => {
        minY = Math.min(minY, recommendationNode.style.y);
        edgesOnPage.push({
          source: recommendationNode.id,
          target: solutionNode.id,
          sourceX: recommendationNode.style.x,
          sourceY: recommendationNode.style.y + 30,
          targetX: solutionNode.style.x+300,
          targetY: solutionNode.style.y + solutionNode.solutionHeight/2,
        });
      });

      pageHeight += groupHeight;
      nextPageEndIndex++;
    }

    pages.push(
      <div key={`page-${pages.length}`}>
        <div className="w-full h-[800px] page-break mb-20 flex flex-1 flex-col">
          <h1
            className={`inline-flex flex-wrap items-center text-center md:text-left break-words text-[20px] sm:text-[26px] md:text-[30px] lg:text-[34px] font-bold  mb-6 ${
              themeMode === "dark" ? "text-[#44a5e4]" : "text-[#44a5e4]"
            }`}
          >
            HOW TO ADDRESS THE FINDINGS
          </h1>
          <div  className="relative w-full h-full">
            {/* Headerları her sayfanın başına ekle */}
            {headers.map((header, index) => (
              <Node
              key={`node-header-${header.id}`}
                label={header.label}
                x={header.x}
                y={header.y} // Header y'yi sıfır olarak ayarla
                type="header"
                themeMode={themeMode}
                header={true}
                id={header.id}
              />
            ))}

            {/* Kenarları çizdir */}
            {edgesOnPage.map((edge, index) => (
              <Edge
              key={`node-edge-${edge.source}-${edge.target}-${index}`}
                sourceX={edge.sourceX}
                sourceY={edge.sourceY - minY + 65}
                targetX={edge.targetX}
                targetY={edge.targetY - minY + 65}
                themeMode={themeMode}
              />
            ))}

            {/* Diğer nodeları ekle */}
            {nodesOnPage.map((node, index) => (
              <Node
              key={`actual-node-${node.id}`}
                label={node.data ? node.data.taskDescription : node.label}
                x={node.style.x}
                y={node.style.y - minY + 65}
                type={node.data ? node.data.type : node.type}
                themeMode={themeMode}
                header={node.header}
                solutionHeight={node.solutionHeight}
              />
            ))}
          </div>
        </div>
        <Line className="no-print " />
      </div>
    );

    currentPageStartIndex = nextPageEndIndex;
  }

  return <div className="w-full flex flex-col">{pages}</div>;
};

export default Graph;
